import axios from '../../plugins/axios.js';

export default {
  async getCampaignSetting(campaignId) {
    return await axios.get(`api/Campaign/GetCampaignSetting/${campaignId}`);
  },
  async updateCampaignSetting(campaignSettings) {
    return await axios.post('/api/Campaign/UpdateCampaignSetting', campaignSettings);
  },
}
